import type { Refund, RefundsPagination } from 'src/interfaces/refund'
import type { State } from '../reducers/types'

export const getRefunds = (state: State): Refund[] => {
  return state.refund.refunds
}

export const getRefundsPagination = (state: State): RefundsPagination => {
  return state.refund.pagination
}

export const getRefundsLoading = (state: State): boolean => {
  return state.refund.loading
}

export const getRefundsError = (state: State): string | null => {
  return state.refund.error
}

export const getRefundExecuting = (state: State): boolean => {
  return state.refund.executing
}
